import { useEffect, useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button/Button";
import ButtonCount from "../../../components/ButtonCount/ButtonCount";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import useStyles from "../styles";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import Badge from "../../../components/Badge/Badge";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";

// --|| Dummy Data
// eslint-disable-next-line no-duplicate-imports
import { useParams } from "react-router-dom";

import { Gender } from "../../../utils/DropDown";
import useValidator from "../../../hooks/useValidator";
import useWindowSize from "../../../hooks/useWindow";

// const APPLICATION_ENDPOINT = "/admin/v1/students";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const CLASSES_ENDPOINT = "/admin/v1/classes";
const CREATE_STUDENT_ENDPOINT = "/admin/v1";

const SchoolStudent = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [createstudentmodal, setCreateStudentModal] = useState();
  const [broadcastModal, setBroadcastModal] = useState(false);
  const [applicationsData, setApplicationsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isApplicationFetching, setIsApplicationFetching] = useState(false);
  const [uploadForm, setUploadForm] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [applicantsFilter, setApplicantsFilter] = useState([]);
  const [ClassLevel, setClassLevel] = useState([]);
  const { id } = useParams();
  const [studentValidator, showStudentValidation] = useValidator();

  const handleCreateStudentModal = () => {
    setCreateStudentModal(!createstudentmodal);
  };

  const handleBroadcastModal = () => {
    setBroadcastModal(!broadcastModal);
  };

  const [studentForm, setStudentForm] = useState({
    first_name: "",
    last_name: "",
    admission_date: "",
    class_admitted: "",
    email: "",
    contact: "",
    gender: "",
    age: ""
    // address: ""
  });

  const { first_name, last_name, admission_date, class_admitted, email, contact, gender, age } = studentForm;

  const getAllClasses = () => {
    httprequest.get(`${CLASSES_ENDPOINT}/${id}`).then((res) => {
      const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassLevel(physicalClasses);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };
  const getAllApplications = () => {
    setIsApplicationFetching(true);
    httprequest
      .get(`/admin/v1/${id}/students`)
      .then((res) => {
        setIsApplicationFetching(false);
        setApplicationsData(res?.data?.data || []);
        setApplicantsFilter(res?.data?.data || []); // Update the filter here
      })
      .catch((err) => {
        setIsApplicationFetching(false);
        toast.error(err?.response?.data);
      });
  };

  const handleCreateStudent = async () => {
    if (studentValidator.allValid()) {
      setIsLoading(true);
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const response = await httprequest.post(
          `${UPLOAD_ENDPOINT}`, formData
        );
        if (response.status === 200 && response.data.data) {
          const upload_id = response.data.data?.upload_id;

          const data = { ...studentForm, upload_id };

          httprequest.post(`${CREATE_STUDENT_ENDPOINT}/${id}/students`, data).then(() => {
            setIsLoading(false);
            toast.success("Student successfully added to the school");
            getAllApplications();
            // --| Reset resource state to original state
            setStudentForm({ ...studentForm, first_name: "", last_name: "", admission_date: "", class_admitted: "",
              email: "", contact: "", guardian: "", gender: "", age: "", address: "" });
            handleCreateStudentModal();
          }).catch((err) => {
            setIsLoading(false);
            toast.error(err?.response?.data.message);
          });
        } else {
          setIsLoading(false);
          toast.error("There is a problem uploading the file");
        }
      } else {
        httprequest.post(`${CREATE_STUDENT_ENDPOINT}/${id}/students`, studentForm).then(() => {
          setIsLoading(false);
          toast.success("Student successfully added to the school");
          getAllApplications();
          // --| Reset resource state to original state
          setStudentForm({ ...studentForm, first_name: "", last_name: "", admission_date: "", class_admitted: "",
            email: "", contact: "", guardian: "", gender: "", age: "", address: "" });
          handleCreateStudentModal();
        }).catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data.message);
        });
      }
    } else {
      showStudentValidation(true);
    }
  };
  const handleRemoveFile = () => setSelectedFile("");
  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedFile(e.target.files[0]);
    setUploadForm({ ...uploadForm, file: e.target.files[0].name.replaceAll(" ", "-") });
  };

  useEffect(() => {
    getAllApplications();
    getAllClasses();
  }, []);

  const width = useWindowSize();
  const mobile = width < 550;

  const columns = [
    {
      name: "Student",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Student</p>}
          { `${row?.student?.last_name} ${row?.student?.first_name}` || "------"}
        </>
      )
    },
    {
      name: "Gender",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Gender</p>}
          {row?.gender || "N/A"}
        </>
      )
    },
    {
      name: "Parent/Guardian",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Parent/Guardian</p>}
          {`${row?.guardian?.last_name || "------"} ${row?.guardian?.first_name || ""}`}
        </>
      )
    },
    {
      name: "Student Status",
      center: true,
      cell: (row) => (
        <Badge status={row?.is_active} />
      )
    },
    {
      name: "Admission Date",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Admission Date</p>}
          {row?.admission_date
            ? new Date(row.admission_date).toLocaleDateString("en-GB")
            : "N/A"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={() => navigate(`/schools/student/${id}`)} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStudentForm((prevForm) => ({
      ...prevForm,
      [name]: value
    }));
  };

  // --| Filter Shelf21 table using name, email and class
  const handleSearchApply = (e) => {
    const { value } = e.target;

    // If the search box is empty, reset the filter to show all applications
    if (!value) {
      setApplicantsFilter(applicationsData);

      return;
    }

    // Convert the input value to lowercase and split it by spaces
    const searchValue = value.toLowerCase();
    const valArray = searchValue.split(" ");

    // Filter applications based on matches in first name, last name, application number, class name, or status
    const result = applicationsData.filter((data) => valArray.every(
      (word) => (data?.first_name && data.first_name.toLowerCase().includes(word)) ||
          (data?.last_name && data.last_name.toLowerCase().includes(word)) ||
          (data?.application_no && data.application_no.toLowerCase().includes(word)) ||
          (data?.class?.name && data.class.name.toLowerCase().includes(word)) ||
          (data?.email && data.email.toLowerCase().includes(word))
    )
    );

    setApplicantsFilter(result);
  };

  return (
    <>
      <div className="flex gap-10 justify-items-space padding-right">
        <div className={classes.contentpadding}>
          <ButtonCount title="Student Count" count={applicationsData.length} />
        </div>
        <div>
          <div className="flex gap-10">
            {/* <Button
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              onClick={handleBroadcastModal}
              buttonName="Send Broadcast to parents"
            /> */}
            <Button
              variant="primary"
              buttonSize="small"
              color="btndefault"
              onClick={handleCreateStudentModal}
              buttonName="Create Students"
            />
          </div>
        </div>
      </div>
      {isApplicationFetching ? (
        // <PageLoader />
        <p></p>
      ) : (
        <Table
          data={applicantsFilter}
          columns={columns}
          pagination
          subHeader={true}
          subHeaderComponent={applicationsData?.length > 0 && (
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchApply} />
          )}
        />
      )}
      {/* Send Broadcast Modal */}
      <Modal
        title="Send Broadcast to parents."
        subtitle={
          <div>Send a broadcast message to the parents of the students in this class
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Broadcast To:"
                  margin="normal"
                  placeHolder="Parent Email"
                  inputType="text"
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Broadcast Message"
                  margin="normal"
                  placeholder="Enter the message you will like to share with the parents."
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <label className={`${classes.label}`}>Additional Information</label>
                <div className={classes.pickercontainers}>
                  <input type="file" className={classes.picker} />

                  <div className={classes.uploadflex}>
                    <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                    <div>
                      <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                      <h6 className={classes.uploadsubtitle}>SVG,PNG,JPG,GIF| 10MB max.</h6>
                    </div>
                  </div>
                  <div className={classes.rightpicker}>
                    <div className={classes.uploadbutton}>Upload</div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
              <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Broadcast" />
            </div>
          </>
        }
        isopen={broadcastModal}
        closeModal={handleBroadcastModal}
      />
      {/* Create Student */}
      <Modal
        title="Add a Student to this school."
        subtitle={
          <div> Add a student to this school, it sends an invite email to them which gives them access to login on their app
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="First Name"
                  margin="normal"
                  inputType="text"
                  onChange={handleChange}
                  inputName="first_name"
                  value={first_name}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Last Name"
                  margin="normal"
                  inputType="text"
                  onChange={handleChange}
                  inputName="last_name"
                  value={last_name}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Student Email"
                  margin="normal"
                  placeHolder="Enter email"
                  inputType="email"
                  inputName="email"
                  onChange={handleChange}
                  value={email}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Age"
                  margin="normal"
                  inputType="number"
                  inputName="age"
                  onChange={handleChange}
                  value={age}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Student Contact"
                  margin="normal"
                  inputType="number"
                  inputName="contact"
                  onChange={handleChange}
                  value={contact}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Admission Date"
                  margin="normal"
                  inputType="date"
                  onChange={handleChange}
                  inputName="admission_date"
                  value={admission_date}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup label="Class Admitted to" children={
                  <select value={class_admitted} name="class_admitted" onChange={handleChange}>
                    <option value="">---Select Labels ---</option>
                    {ClassLevel?.map((label) => {
                      return (
                        <option key={label?.id} value={label?.id}>{label?.class_name}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid>
              {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Address"
                      margin="normal"
                      inputType="text"
                      inputName="address"
                      value={address}
                      onChange={handleStudentChange}
                    />
                  </Grid> */}
              {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup label="Parent/Guardian" children={
                  <select>
                    <option value="">---Select  ---</option>
                    {Employees?.map((label) => {
                      return (
                        <option key={label?.key}>{label?.text}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid> */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup label="Gender" children={
                  <select value={gender} name="gender" onChange={handleChange}>
                    <option value="">---Select  ---</option>
                    {Gender?.map((label) => {
                      return (
                        <option key={label?.key}>{label?.text}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <label className={`${classes.label}`}>Upload supporting documents<span className="input-required">*</span> </label>
                <div className={classes.pickercontainer}>
                  <input type="file" className={classes.picker} onChange={handleFileChange} name="file" accept=".pdf" />

                  <div className={classes.uploadflex}>
                    <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                    {selectedFile?.name ? (
                      <div>
                        <h2 className={classes.uploadtitle}>{selectedFile?.name}</h2>
                      </div>
                    ) :
                      <div>
                        <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                        <h6 className={classes.uploadsubtitle}>PDF| 10MB max.
                        </h6>
                      </div>}
                  </div>
                  <div className={classes.rightpicker}>
                    {selectedFile?.name ? (
                      <div className={classes.uploadbutton} onClick={handleRemoveFile}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                    ) : null}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
              <Button variant="primary" buttonSize="full" color="btndefault" isLoading={isLoading} onClick={handleCreateStudent} buttonName="Add Student" />
            </div>
          </>
        }
        isopen={createstudentmodal}
        closeModal={handleCreateStudentModal}
      />
      {/* Delete Modal */}
      <Modal
        title="Delete Student School"
        subtitle={
          <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.student_name}</span>.If leave you delete, school will no longer have access to this platform.`
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
              />
              <Button variant="danger" buttonName="Delete Student" buttonSize="full" color="btndefault" />
            </div>
          </>
        }
        isopen={deleteModal}
        closeModal={handleDeleteModal}
      />
      <ToastContainer />

    </>
  );
};

export default SchoolStudent;
